import i18n from "../i18n";

const Coach = (app) => {
  app.post("/coach/generate-zapier-key", async ({ res, api, flash }) => {
    const r = await api("generate-zapier-key", { method: "POST", body: {} });
    if (!r.ok)
      flash("error", i18n.t("dashboard:pullPreferences.zapierKeyError"));
    res.backDontScroll();
  });
};

export default Coach;
